import { ellipsis } from "polished";
import styled, { css } from "styled-components";

import { T_BOLD_tiny } from "../../../global.style";

export const StyledError = styled.div<{ $isIconButtonError?: boolean }>`
    position: absolute;

    width: 100%;
    margin-left: 0;
    background-color: ${props => props.theme.C_SEM_el_bad};
    height: 3px;
    border-bottom-right-radius: 1.5px;
    border-top-right-radius: 1.5px;
    z-index: 5;

    ${props => props.$isIconButtonError && css`
        height: 100%;
        border: 3px solid transparent;
        border-top: 3px solid ${props => props.theme.C_SEM_el_bad};
        border-radius: 1000px;
        background-color: transparent;
        top: 0;
    `};
`;

export const Circle = styled.div<{ $isIconButtonError?: boolean }>`
    position: absolute;
    top: ${props => props.$isIconButtonError ? "10%" : "0"}; 
    left: 1px;
    width: 16px;
    height: 16px;
    background-color: ${props => props.theme.C_SEM_el_bad};

    // we will position center of the circle by top/left position
    transform: translate(-50%, -50%);
    border-radius: 50%;

    display: flex;
    justify-content: center;
`;

export const ErrorText = styled.div`
    position: absolute;
    width: 100%;
    top: 3px;
    left: 0;
    ${ellipsis("100%")}
    ${T_BOLD_tiny};
    user-select: none;
    pointer-events: none;
`;
